import React from "react"
import Button from "../Button"
import Container from "../Container"

function Projects() {
  return (
    <Container className="">
      <div className="mt-[128px] mb-[268px] flex flex-col gap-[50px]">
        <p className="text-[24px] w-[80%] lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
          PROTECTING YOUR HOME WITH EXCELLENCE
        </p>
        <div className="flex gap-[10px]">
          <Button text="GET A QUOTE" variant="filled" />
          <Button text="CONTACT US" variant="outline" />
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full">
          <div className="border flex flex-col justify-center items-center rounded-[10px] px-[25px] py-[40px] border-1 border-[#D6D6D6] px-[16px] py-[10px] ">
            <p className="font-[700] text-[36px] ">1000+</p>
            <p className="font-[400] text-[12px] text-[#222222]">
              HAPPY CUSTOMERS
            </p>
          </div>
          <div className="border flex flex-col justify-center items-center rounded-[10px] px-[25px] py-[40px] border-1 border-[#D6D6D6] px-[16px] py-[10px] ">
            <p className="font-[700] text-[36px] ">5000+</p>
            <p className="font-[400] text-[12px] text-[#222222]">
              COMPLETED PROJECTS
            </p>
          </div>
          <div className="border flex flex-col justify-center items-center rounded-[10px] px-[25px] py-[40px] border-1 border-[#D6D6D6] px-[16px] py-[10px] ">
            <p className="font-[700] text-[36px] ">25+</p>
            <p className="font-[400] text-[12px] text-[#222222]">
              YEARS IN BUSINESS
            </p>
          </div>
          <div className="border flex flex-col justify-center items-center rounded-[10px] px-[25px] py-[40px] border-1 border-[#D6D6D6] px-[16px] py-[10px] ">
            <p className="font-[700] text-[36px] ">150</p>
            <p className="font-[400] text-[12px] text-[#222222]">
              TEAM MEMBERS
            </p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Projects
